<template>
    <div class="vertical-container">
        <div class="vertical-container__content">
            <div class="container">
                <div class="onboarding">
                    <div class="onboarding__form onboarding__form--unit">
                        <h1 class="m--b-05">Webová prezentace</h1>
                        <template v-if="site">
                            <p>
                                <strong class="text--info">Vaše prezentace je připravena.</strong><br>
                                Přejděte na její editaci&hellip;
                            </p>
                            <custom-button primary @click="visit" class="m--t-2">
                                Začít s editací
                            </custom-button>
                        </template>
                        <template v-else>
                            <p>
                                Zatím jste žádnou prezentaci <span class="text--maroon">nezaložili</span>.<br>
                                Klikněte tedy na tlačítko níže, nastavte parametry vaší prezentace,<br>zeditujte její obsah a <strong class="text--info">ukažte váš nový projekt světu</strong>.
                            </p>
                            <custom-button primary @click="create" class="m--t-2">
                                {{ processing ? 'Minutku, vytváříme prezentaci&hellip;' : 'Založit webovou prezentaci' }}
                            </custom-button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {createSite} from '@/modules/ProjectModule/modules/api/site.api';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    components: {CustomButton},
    data() {
        return {
            site:       null,
            processing: false,
        }
    },
    methods:    {
        create() {
            const projectId = this.$store.getters['projects/project/projectId'];
            this.processing = true;
            createSite({projectId})
                .then((site) => this.site = site)
                .catch((message) => this.$dmv.notifyError(message))
                .finally(() => this.processing = false);
        },
        visit() {
            window.location.href = this.$dmv.env.EDITOR_DOMAIN + '/' + this.site.id
        }
    }
}
</script>
